/**
 * Trocha66 · extras de la galería de producto.
 * Agrega a la galería nativa de Fabric un contador "01 / 04" y un botón "Ampliar"
 * que abre el zoom nativo (zoom-dialog). No reemplaza la galería: solo la acompaña.
 */

const COUNT_CLASS = 't66-gallery-count';
const EXPAND_CLASS = 't66-gallery-expand';

/** @param {number} value */
const pad = (value) => String(value).padStart(2, '0');

/** @param {Element} gallery */
function getSlideshow(gallery) {
  return gallery.querySelector('slideshow-component');
}

/** @param {Element} gallery */
function updateCount(gallery) {
  const count = gallery.querySelector(`.${COUNT_CLASS}`);
  const slideshow = getSlideshow(gallery);
  if (!count || !slideshow) return;

  const total = slideshow.querySelectorAll('slideshow-slide').length || 1;
  const current = Number(/** @type {{ current?: number }} */ (slideshow).current ?? 0) + 1;
  count.textContent = `${pad(current)} / ${pad(total)}`;
}

/** @param {Element} gallery */
function enhance(gallery) {
  if (!(gallery instanceof HTMLElement) || gallery.querySelector(`.${COUNT_CLASS}`)) return;

  const source = document.querySelector('[data-t66-expand-text]');
  const text = source?.getAttribute('data-t66-expand-text') || 'Ampliar ↗';
  const aria = source?.getAttribute('data-t66-expand-label') || 'Ampliar';

  const count = document.createElement('span');
  count.className = COUNT_CLASS;
  count.setAttribute('aria-hidden', 'true');

  const expand = document.createElement('button');
  expand.type = 'button';
  expand.className = EXPAND_CLASS;
  expand.textContent = text;
  expand.setAttribute('aria-label', aria);
  expand.addEventListener('click', () => {
    const zoom = gallery.querySelector('zoom-dialog');
    const slideshow = getSlideshow(gallery);
    const index = Number(/** @type {{ current?: number }} */ (slideshow ?? {}).current ?? 0);
    if (zoom && typeof (/** @type {any} */ (zoom).open) === 'function') /** @type {any} */ (zoom).open(index);
  });

  gallery.append(count, expand);
  updateCount(gallery);
}

function enhanceAll() {
  document.querySelectorAll('media-gallery').forEach(enhance);
}

document.addEventListener('slideshow:select', (event) => {
  const gallery = event.target instanceof Element ? event.target.closest('media-gallery') : null;
  if (gallery) updateCount(gallery);
});

// Fabric puede reemplazar el contenido de <main> (productos conectados): se vuelve a aplicar.
const main = document.querySelector('main');
if (main) new MutationObserver(enhanceAll).observe(main, { childList: true, subtree: true });

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enhanceAll, { once: true });
} else {
  enhanceAll();
}
